import { useMemo } from 'react';

import { useProviderPayables } from '../context/ProviderPayablesContext';
import { ServiceProviderPaymentConstraints, sumActiveProviderPayments } from '../helpers/providerPaymentConstraints';

export const useServiceProviderPaymentConstraints = (serviceId: string): ServiceProviderPaymentConstraints => {
	const { getLinesForService, loading } = useProviderPayables();

	return useMemo(() => {
		const lines = getLinesForService(serviceId);
		const totalPaidToProvider = sumActiveProviderPayments(lines);
		const hasProviderPayments = !loading && totalPaidToProvider > 0;

		return {
			loading,
			totalPaidToProvider,
			hasProviderPayments,
			lockTariffProvider: hasProviderPayments,
			minAllowedCost: totalPaidToProvider,
		};
	}, [getLinesForService, loading, serviceId]);
};
